import { useState } from "react";
import { PendingMessage } from "../../../types/chat-support/chat-support.type";
import { ActiveChatMsg } from "../atoms/active-chat-msg";
import { useChatSupport } from "../../../context/chat-support/chat-support.context";
import { useChatSupportActiveMessages } from "../../../context/chat-support/chat-support-active-chat.context";
import { IoMdAlert } from "react-icons/io";
import { Spinner } from "../../shared/atoms/spinner";
import { useEffectOnce } from "../../../customHooks/useEffect-once";
import { scrollToBottom } from "../../../utils/util";

type Props = {
  message: PendingMessage;
};
export const ActiveChatPendingMessage = ({ message }: Props) => {
  const [isErrorSaving, setIsErrorSaving] = useState(false);
  const [uploadProgress, setUploadProgress] = useState("");
  const {
    actions,
    states: {
      activeChatRoom: { setActiveChatRoom },
    },
  } = useChatSupport();
  const {
    states: {
      pending: { setPendingMsgs },
      messages: { msgsContainerRef },
    },
  } = useChatSupportActiveMessages();
  const sendMessage = async () => {
    try {
      isErrorSaving && setIsErrorSaving(false);
      const isImg = !!message.file;
      await actions.sendMessage(message, isImg ? setUploadProgress : undefined);
      setPendingMsgs((old) => old.filter((old) => old.tempId !== message.tempId));

      setTimeout(() => scrollToBottom(msgsContainerRef), 200);
    } catch (error) {
      setIsErrorSaving(true);
      setUploadProgress("");
    }
  };

  useEffectOnce(() => {
    sendMessage();
  });
  return (
    <div className=" flex  gap-2 ms-auto items-center ">
      {uploadProgress && <Spinner className=" size-12"> {uploadProgress}%</Spinner>}
      <ActiveChatMsg message={message} />
      <IoMdAlert
        className={`text-red-500 text-xl cursor-pointer transition-opacity ${
          isErrorSaving ? " opacity-1" : "opacity-0"
        }`}
        onClick={sendMessage}
      />
    </div>
  );
};
